import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Icon } from 'semantic-ui-react';
import { hideModal } from 'erisxkit/client';
import styled from 'styled-components';
import history from '../../constants/history';
import TextButton from '../../common/TextButton';
import { sizes } from '../../styles/styled';

const Header = styled.h3`
  font-size: 2em;
  font-weight: 500;
  align-self: end;
  margin: 0px auto 10px auto;
  text-align: center;
  padding-top: 10px;
`;

const Text = styled.p`
  font-size: 20px;
  margin: 2em 0px;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 2em 0px;

  ${Text} {
    margin: 0px;
  }
`;
const Check = styled(Icon)`
  margin-right: 20px !important;
  @media (max-width: ${sizes.SMALL}) {
    display: none !important;
  }
`;

const Reset2faModal = () => {
  const dispatch = useDispatch();
  return (
    <>
      <Modal.Content>
        <Header>Reset 2FA</Header>
        <>
          <Wrapper>
            <Check name="check circle green" size="huge" />
            <Text>
              Two-Factor Authentication is enabled for your account. If you have
              a new phone and need to reset your 2FA, please{' '}
              <TextButton
                fontSize="20"
                text="contact support."
                onClick={() => {
                  dispatch(hideModal());
                  history.push('/contact');
                }}
              />
            </Text>
          </Wrapper>
        </>
      </Modal.Content>
    </>
  );
};

export default Reset2faModal;
